import { tv } from 'tailwind-variants'

export const progressVariants = tv({
  base: ['h-full', 'rounded-full'],
  variants: {
    accentColor: {
      none: 'bg-white',
      yellow: 'bg-yellow',
      blue: 'bg-blue',
      green: 'bg-green',
      pink: 'bg-pink'
    }
  },
  defaultVariants: {
    accentColor: 'none'
  }
})
